import React, { useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { ButtonBase } from "@material-ui/core";
import { InputAdornment } from "@material-ui/core";
import { TableActions } from "../../../../../../../Enums";
import { Inputs, Tables, Spinner } from "../../../../../../../Components";
import { MessageConfirmDialog } from "../../../../../../../SharedComponents";
import { ReactComponent as TrashIcon } from "../../../../../../../assets/images/defaults/trash.svg";
import { ReactComponent as EditIcon } from "../../../../../../../assets/images/defaults/edit-02.svg";
import { formatCommasForPriceUnit } from "../../../../../../../Helper/formatCommas.Helper";
import { EditPSICommissionSlabDialog } from "./EditPSICommissionSlabDialog";

export const PSICommissionSlabsComponents = ({
  parentTranslationPath,
  translationPath,
  selected,
  setSelected,
  setRangesValues,
  rangeValues,
  dispatch,
}) => {
  const { t } = useTranslation(parentTranslationPath);
  const [activeSlab, setActiveSlab] = useState(null);
  const [indexValue, setIndexValue] = useState(false);
  const [isEditPSICommissionSlabDialog, setIsEditPSICommissionSlabDialog] =
    useState(false);
  const [isMissingInfoMSGOpen, setIsMissingInfoMSGOpen] = useState(false);

  const tableActionClicked = useCallback((actionEnum, item, focusedRow) => {
    setActiveSlab(item);
    setIndexValue(focusedRow);
    if (actionEnum === TableActions.delete.key) {
      setIsMissingInfoMSGOpen(true);
    } else if (actionEnum === TableActions.editText.key) {
      setIsEditPSICommissionSlabDialog(true);
    }
  }, []);

  const deleteHandler = useCallback(
    async () => {
      if (indexValue !== -1) {
        let newList = selected?.psiCommissionSlabs
          ? [...selected.psiCommissionSlabs]
          : [];
        newList.splice(indexValue, 1);
        setSelected({
          ...selected,
          psiCommissionSlabs: [...newList],
        });
        dispatch({ id : 'psiCommissionSlabs' ,  value : newList })
        setIndexValue(null);
        setActiveSlab(null);
      }
      setIndexValue(null);
      setIsMissingInfoMSGOpen(false);
    },
    [activeSlab, indexValue]
  );

  return (
    <div className="w-100 mt-2 mb-2 d-flex-column">
      <div>
        <span>
          {t`${translationPath}you_can_leave_the_Range_to_field_blank_if_you_want_the_Range_from_amount_to_mean_and_above`}
        </span>
        <div
          className={`w-100 d-flex d-inline-flex d-flex-v-center-h-between mt-2  mb-2`}
          key={`a-less-than`}
        >
          <div className={`w-33`}>
            <Inputs
              labelValue={"from"}
              labelClasses="Requierd-Color"
              wrapperClasses={"theme-form-builder"}
              parentTranslationPath={parentTranslationPath}
              translationPath={translationPath}
              inputPlaceholder={"enter_from_less_than_to"}
              min={0}
              value={rangeValues?.from || ""}
              type={"number"}
              onInputChanged={(e) => {
                let { value } = e.target;
                if (value < 0) value = value * -1;
                setRangesValues((range) => ({
                  ...range,
                  from: value,
                }));
              }}
              withNumberFormat
              endAdornment={
                <InputAdornment position="start" className="px-2">
                  AED
                </InputAdornment>
              }
            />
          </div>
          <div className={`w-33 px-1`}>
            <Inputs
              labelValue={"to"}
              wrapperClasses={"theme-form-builder"}
              parentTranslationPath={parentTranslationPath}
              inputPlaceholder={"enter_to_greater_than_from"}
              min={0}
              value={rangeValues?.to || ""}
              type={"number"}
              onInputChanged={(e) => {
                let { value } = e.target;
                if (value < 0) value = value * -1;
                setRangesValues((range) => ({
                  ...range,
                  to: value,
                }));
              }}
              withNumberFormat
              endAdornment={
                <InputAdornment position="start" className="px-2">
                  AED
                </InputAdornment>
              }
            />
          </div>
          <div className={`w-33 px-1`}>
            <Inputs
              labelValue={"commission"}
              labelClasses="Requierd-Color"
              wrapperClasses={"theme-form-builder"}
              parentTranslationPath={parentTranslationPath}
              inputPlaceholder={"enter_commission_percentage"}
              min={0}
              value={rangeValues?.commission || ""}
              type={"number"}
              onInputChanged={(e) => {
                let { value } = e.target;
                if (value > 100) value = 100;
                else if (value < 0) value = value * -1;

                setRangesValues((range) => ({
                  ...range,
                  commission: value,
                }));
              }}
              withNumberFormat
              endAdornment={
                <InputAdornment position="start" className="px-2">
                  %
                </InputAdornment>
              }
            />
          </div>{" "}
        </div>
      </div>
      <div className="w-100 d-flex-v-center-h-between">
        <span className="">
          <ButtonBase
            className="btns  mt-2"
            disabled={!rangeValues.from || !rangeValues.commission}
            onClick={() => {
              let newlist = selected?.psiCommissionSlabs
                ? [...selected.psiCommissionSlabs]
                : [];
              newlist.push({
                rangeFrom: rangeValues?.from || 0,
                rangeTo: rangeValues?.to || 0,
                commissionPercentage: rangeValues?.commission || 0,
                id: 0,
              });
              setRangesValues((range) => ({
                ...range,
                from: null,
                to: null,
                commission: null,
              }));
              dispatch({ id: "psiCommissionSlabs", value: newlist });
              setSelected({ ...selected, psiCommissionSlabs: newlist });
            }}
          >
            <span className="mdi mdi-plus c-primary" />
            {t`${translationPath}add_another`}
          </ButtonBase>
          <ButtonBase
            className="btns btns theme-outline c-red clear-all-btn  mt-2"
            onClick={() => {
              setRangesValues((range) => ({
                ...range,
                from: 0,
                to: 0,
                commission: 0,
              }));
            }}
          >
            <span className="mdi mdi-delete" />
            {t`${translationPath}clear`}
          </ButtonBase>
        </span>
      </div>
      <div className="d-flex-column mt-2">
        <Tables
          data={selected?.psiCommissionSlabs || []}
          headerData={[
            {
              id: 1,

              label: `amountfrom`,
              input: "rangeFrom",
              component: (row) =>
                (row.rangeFrom &&
                  `${formatCommasForPriceUnit(row.rangeFrom)} AED`) ||
                "",
            },
            {
              id: 2,

              label: `amount_to`,
              input: "rangeTo",
              component: (row) =>
                (row.rangeTo &&
                  `${formatCommasForPriceUnit(row.rangeTo)} AED`) ||
                "",
            },
            {
              id: 3,

              label: `commission`,
              input: "commissionPercentage",
              component: (row) =>
                row.commissionPercentage && `${row.commissionPercentage} %`,
            },
            {
              id: 4,
              label: "actions",
              input: "action",
              component: (item, index) => (
                <div className="d-flex-inline">
                  <span
                    className="d-flex-center-h-start px-2"
                    onClick={() => {
                      tableActionClicked("editText", item, index);
                    }}
                    title={t`${translationPath}edit_slab`}
                  >
                    <EditIcon />
                  </span>
                  <span
                    className="d-flex-center-h-start px-2"
                    onClick={() => {
                      tableActionClicked("delete", item, index);
                    }}
                    title={t`${translationPath}delete_slab`}
                  >
                    <TrashIcon />
                    <span />
                  </span>
                </div>
              ),
            },
          ]}
          defaultActions={[]}
          parentTranslationPath={parentTranslationPath}
          onPageIndexChanged={() => {}}
          onPageSizeChanged={() => {}}
        />
        {isMissingInfoMSGOpen && activeSlab && (
          <MessageConfirmDialog
            isDialogOpen={isMissingInfoMSGOpen}
            theme="warning"
            content={{
              heading: t`${translationPath}delete_slab_data`,
              body: t`${translationPath}are_you_sure_to_delete_this_slab`,
            }}
            confirmButton={{
              label: t`${translationPath}confirm`,
              handler: deleteHandler,
            }}
            cancelButton={{
              label: t`${translationPath}discard`,
              handler: () => {
                setIsMissingInfoMSGOpen(false);
              },
            }}
            parentTranslationPath={parentTranslationPath}
          />
        )}
        {isEditPSICommissionSlabDialog && activeSlab && (
          <EditPSICommissionSlabDialog
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
            isOpen={isEditPSICommissionSlabDialog}
            onClose={() => {
              setIndexValue(null);
              setIsEditPSICommissionSlabDialog(false);
              setActiveSlab(null);
            }}
            onSave={() => {
              setIsEditPSICommissionSlabDialog(false);
              setIndexValue(null);
              setActiveSlab(null);
            }}
            activeSlab={activeSlab}
            setSelected={setSelected}
            selected={selected}
            slabIndex={indexValue}
            dispatch={dispatch}
          />
        )}
      </div>
    </div>
  );
};
